import React from "react";
import "./DepartDetail.css";
export const formatDuration = (minutes) => {
  const hrs = String(Math.floor(minutes / 60)).padStart(2, "0");
  const mins = String(minutes % 60).padStart(2, "0");
  return `${hrs}h ${mins}m`;
};
const DepatureDetail = ({ srdvIdx, flight, type, flight2, flight3, types }) => {  
  const formatTime = (arrTime) => {
    const date = new Date(arrTime);
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = days[date.getDay()];
    const dateNum = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day}, ${dateNum} ${month} ${year}`;
  };

  const formatLayoverTime = (arrivalTime, nextDepartureTime) => {
    const arrival = new Date(arrivalTime);
    const nextDeparture = new Date(nextDepartureTime);
    const layoverMinutes = Math.floor(
      (nextDeparture.getTime() - arrival.getTime()) / (1000 * 60)
    );
    const layoverHours = Math.floor(layoverMinutes / 60);
    const layoverMinutesRemainder = layoverMinutes % 60;
    return `${layoverHours}h : ${layoverMinutesRemainder}m`;
  };


  console.log("flightdepdetail", flight2);
  console.log("flightdepdetail flight3  ", flight3);
  const cabinClass = {
    1: "All",
    2: "Economy",
    3: "Premium Economy",
    4: "Business",
    5: "Premium Business",
    6: "First Class",
  };
  return (
    <>
      <div
        className="block-content-2 custom_block_content flight_detail_webTG"
        //     style={{

        //   boxShadow: type === "Return" ? "none" : "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
        // }}
      >
        {srdvIdx != "undefined" && (
          <div
            className="box-result custom_box_result"
            style={{ display: "block" }}
          >
            {flight?.Segments?.[0]?.length > 0 && (
              <>
                <div className="flight_tags depart_tags">
                  <span style={{ zIndex: 2 }}>{type}</span>
                </div>
                {flight.Segments[0].map((segment, index) => (
                  <React.Fragment key={index}>
                    <ul className="list-search-result booking_list forMinScreenul">
                      <li className="flight_name">
                        <img
                          src={`/Images/AirlineLogo/${segment.Airline.AirlineCode}.gif`}
                          alt=""
                          style={{ width: "50px" }}
                        />

                        <div className="name">
                          {" "}
                          {segment.Airline.AirlineName}
                          <span className="flight_no">
                            {segment.Airline.AirlineCode}-
                            {segment.Airline.FlightNumber}
                          </span>
                          <span className="flightBookingHiddenTitle">
                            Economy
                          </span>
                        </div>
                      </li>
                      <li className="flight_time">
                        <span className="flightBookingHiddenDelhi">
                          {" "}
                          {segment.Origin.Airport.CityName},{" "}
                          {segment.Origin.Airport.CountryCode}
                        </span>
                        <strong>
                          {new Date(segment.Origin.DepTime).toLocaleTimeString(
                            [],
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            }
                          )}
                        </strong>
                        <span className="date">
                          {formatTime(segment.Origin.DepTime)}
                        </span>
                        <span className="flightBookingHiddenTitle">
                          {" "}
                          {segment.Origin.Airport.CityName},{" "}
                          {segment.Origin.Airport.CountryCode}
                        </span>
                        <span className="airport">
                          {" "}
                          {segment.Origin.Airport.AirportName} , Terminal{" "}
                          {segment.Origin.Airport.Terminal}
                        </span>
                      </li>
                      <li className="flight_amenties">
                        <div className="top">
                          <span className="duration">
                            <i
                              className="fa fa-clock"
                              style={{ marginRight: "3px" }}
                            />
                            {segment.Duration} 
                          </span>
                          <span className="flightDetailSpantag"></span>
                          <span className="grey_rtbrder">|</span>{" "}
                          <span className="flightBookingHiddenDelhi">
                            {cabinClass[segment.CabinClass]}{" "}
                          </span>
                        </div>

                        <div className="middle">
                          <span className="txt flighttxt">
                            <i className="fa fa-plane" />
                          </span>
                        </div>

                        <div className="bottom">
                          {segment.Baggage && (
                            <span className="wght">
                              {flight.Segments[0][0].Baggage}
                            </span>
                          )}

                          {segment.Baggage && flight.refundtype === "Refundable" && (
                            <span className="grey_rtbrder">|</span>
                          )}

                          <>
                            <span className="refundable">
                              {" "}
                              {flight.refundtype === "Refundable"
                                ? "Refundable"
                                : "Non Refundable"}
                            </span>
                          </>
                        </div>
                      </li>
                      <li className="flight_time">
                        <span className="flightBookingHiddenDelhi">
                          {segment.Destination.Airport.CityName},{" "}
                          {segment.Destination.Airport.CountryCode}
                        </span>
                        <strong>
                          {new Date(
                            segment.Destination.ArrTime
                          ).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          })}
                        </strong>
                        <span className="date">
                          {formatTime(segment.Destination.ArrTime)}
                        </span>
                        <span className="flightBookingHiddenTitle">
                          {" "}
                          Pune, IN
                        </span>
                        <span className="airport">
                          {" "}
                          {segment.Destination.Airport.AirportName} , Terminal{" "}
                          {segment.Destination.Airport.Terminal}{" "}
                        </span>
                      </li>
                    </ul>
                    <div className="clearfix" />
                    {index < flight.Segments[0].length - 1 && (
                      <div className="layover_time">
                        <div className="layover_txt">
                          Layover:
                          <span>
                            {segment.Layover}
                          </span>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </>
            )}
            {flight3 && (
              <>
                <div className="flight_tags depart_tags">
                  <span style={{ zIndex: 2 }}>{types}</span>
                </div>
                {flight3.Segments[1].map((segment, index) => (
                  <React.Fragment key={index}>
                    <ul className="list-search-result booking_list forMinScreenul">
                      <li className="flight_name">
                        <img
                          src={`/Images/AirlineLogo/${segment.Airline.AirlineCode}.gif`}
                          alt=""
                          style={{ width: "50px" }}
                        />

                        <div className="name">
                          {" "}
                          {segment.Airline.AirlineName}
                          <span className="flight_no">
                            {segment.Airline.AirlineCode}-
                            {segment.Airline.FlightNumber}
                          </span>
                          <span className="flightBookingHiddenTitle">
                            {cabinClass[segment.CabinClass]}
                          </span>
                        </div>
                      </li>
                      <li className="flight_time">
                        <span className="flightBookingHiddenDelhi">
                          {" "}
                          {segment.Origin.Airport.CityName},{" "}
                          {segment.Origin.Airport.CountryCode}
                        </span>
                        <strong>
                          {new Date(segment.Origin.DepTime).toLocaleTimeString(
                            [],
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            }
                          )}
                        </strong>
                        <span className="date">
                          {formatTime(segment.Origin.DepTime)}
                        </span>
                        <span className="flightBookingHiddenTitle">
                          {" "}
                          {segment.Origin.Airport.CityName},{" "}
                          {segment.Origin.Airport.CountryCode}
                        </span>
                        <span className="airport">
                          {" "}
                          {segment.Origin.Airport.AirportName} , Terminal{" "}
                          {segment.Origin.Airport.Terminal}
                        </span>
                      </li>
                      <li className="flight_amenties">
                        <div className="top">
                          <span className="duration">
                            <i
                              className="fa fa-clock"
                              style={{ marginRight: "3px" }}
                            />
                            {segment.Duration} 
                          </span>
                          <span className="flightDetailSpantag"></span>
                          <span className="grey_rtbrder">|</span>{" "}
                          <span className="flightBookingHiddenDelhi">
                            {cabinClass[segment.CabinClass]}{" "}
                          </span>
                        </div>

                        <div className="middle">
                          <span className="txt flighttxt">
                            <i className="fa fa-plane" />
                          </span>
                        </div>

                        <div className="bottom">
                          {segment.Baggage && (
                            <span className="wght">
                              {flight3.Segments[1][0].Baggage}
                            </span>
                          )}

                          {segment.Baggage && flight3.refundtype === "Refundable" && (
                            <span className="grey_rtbrder">|</span>
                          )}

                          <>
                            <span className="refundable">
                              {" "}
                              {flight3.refundtype === "Refundable"
                                ? "Refundable"
                                : "Non Refundable"}
                            </span>
                          </>
                        </div>
                      </li>
                      <li className="flight_time">
                        <span className="flightBookingHiddenDelhi">
                          {segment.Destination.Airport.CityName},{" "}
                          {segment.Destination.Airport.CountryCode}
                        </span>
                        <strong>
                          {new Date(
                            segment.Destination.ArrTime
                          ).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          })}
                        </strong>
                        <span className="date">
                          {formatTime(segment.Destination.ArrTime)}
                        </span>
                        <span className="flightBookingHiddenTitle">
                          {" "}
                          Pune, IN
                        </span>
                        <span className="airport">
                          {" "}
                          {segment.Destination.Airport.AirportName} , Terminal{" "}
                          {segment.Destination.Airport.Terminal}{" "}
                        </span>
                      </li>
                    </ul>
                    <div className="clearfix" />
                    {index < flight3.Segments[1].length - 1 && (
                      <div className="layover_time">
                        <div className="layover_txt">
                          Layover:
                          <span>
                            {segment.Layover}
                          </span>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </>
            )}
          </div>
        )}
        
      </div>
      {flight && (
        <section className="flt-area flight_detail_phoneTG">
          <div className="flt-container">
            <div className="cardFlgbx">
              <div className="crd-head">
                <div className="fnt-18 fnt-600 ng-binding">
                  {" "}
                  {flight.Segments[0][0].Origin.Airport.CityName}-
                  {
                    flight.Segments[0][flight.Segments[0].length - 1]
                      .Destination.Airport.CityName
                  }
                </div>
                <div className="flt-tp">
                  <span className="fnt-11 clr-grey ng-binding">
                    {formatTime(flight.Segments[0][0].Origin.DepTime)}
                  </span>{" "}
                  <span className="depblue ng-scope">{type}</span>
                </div>
              </div>
              {flight.Segments[0].map((segment, index) => (
                <div>
                  <div className="FlghtBoxNew mt-5 ng-scope">
                    <div className="clr" />

                    <div className="card-head  d-flex gap-10 align-items-center">
                      <img
                        src={`/Images/AirlineLogo/${segment.Airline.AirlineCode}.gif`}
                      />
                      <div className="flt-nm">
                        <span
                          className="fnt-600 ng-binding"
                          ng-bind="l.airName"
                        >
                          {segment.Airline.AirlineName}
                        </span>{" "}
                        |{" "}
                        <span className="fnt-500 fnt-15 ng-binding">
                          {" "}
                          {segment.Airline.AirlineCode}-
                          {segment.Airline.FlightNumber}
                        </span>
                      </div>

                      <span className="rfnd-btn fnt-10 ng-binding ng-scope">
                        {flight.refundtype === "Refundable"
                          ? "Refundable"
                          : "Non Refundable"}
                      </span>
                    </div>

                    <span
                      className="secre ng-binding ng-scope"
                      style={{ display: "block" }}
                    >
                      {flight.ResultFareType} | {cabinClass[segment.CabinClass]}
                    </span>

                    <div className="card-body d-flex justify-content-between gap-10 align-items-center1">
                      <div className="ft-frm w-35 ">
                        <div className="fnt-12 clr-drkgrey ng-binding">
                          {formatTime(segment.Origin.DepTime)}
                        </div>
                        <div className="d-flex gap-5">
                          <div className="frm fnt-16 fnt-600 ng-binding">
                            {" "}
                            {segment.Origin.Airport.CityCode}
                          </div>
                          <div className="fnt-16 fnt-600 ng-binding">
                            {" "}
                            {new Date(
                              segment.Origin.DepTime
                            ).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            })}
                          </div>
                        </div>
                        <div className="clr-drkgrey fnt-15 fw600 ng-binding">
                          {segment.Origin.Airport.CityName}
                        </div>

                        <div className="clr-drkgrey fnt-10 arpt ng-binding ng-scope">
                          {segment.Origin.Airport.Terminal !== "" && (
                            <>Terminal - {segment.Origin.Airport.Terminal}</>
                          )}
                        </div>
                      </div>
                      <div
                        className="jrny w-20 text-center"
                        style={{ margin: "10px auto" }}
                      >
                        <div className="clr-drkgrey fnt-11 ng-binding">
                          <span> ... </span> {segment.Duration} {" "}
                          <span> ...</span>
                        </div>
                      </div>
                      <div className="ft-to w-35 text-end">
                        <div className="fnt-12 clr-drkgrey ng-binding">
                          {formatTime(segment.Destination.ArrTime)}
                        </div>
                        <div className="d-flex gap-5 justify-content-end">
                          <div className="frm fnt-16 fnt-600 ng-binding">
                            {" "}
                            {segment.Destination.Airport.CityCode}
                          </div>
                          <div className="fnt-16 fnt-500 ng-binding">
                            {" "}
                            {new Date(
                              segment.Destination.ArrTime
                            ).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            })}
                          </div>
                        </div>
                        <div className="clr-drkgrey fnt-16 fw600 ng-binding">
                          {segment.Destination.Airport.CityName}
                        </div>
                        <div className="clr-drkgrey fnt-10 arpt ng-binding ng-scope">
                          {segment.Destination.Airport.Terminal !== "" && (
                            <>
                              Terminal - {segment.Destination.Airport.Terminal}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {index < flight.Segments[0].length - 1 && (
                    <div className="FlghtBoxNew mt-5 ng-scope">
                      <div className="clr" />

                      <div className="lyovr  ng-scope">
                        <span className="ng-binding">
                          {segment.Layover}{" "}
                          Layover{" "}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {flight3 && (
        <section className="flt-area flight_detail_phoneTG">
          <div className="flt-container">
            <div className="cardFlgbx">
              <div className="crd-head">
                <div className="fnt-18 fnt-600 ng-binding">
                  {" "}
                  {flight3.Segments[1][0].Origin.Airport.CityName}-
                  {
                    flight3.Segments[1][flight3.Segments[1].length - 1]
                      .Destination.Airport.CityName
                  }
                </div>
                <div className="flt-tp">
                  <span className="fnt-11 clr-grey ng-binding">
                    {formatTime(flight3.Segments[1][0].Origin.DepTime)}
                  </span>{" "}
                  <span className="depblue ng-scope">{type}</span>
                </div>
              </div>
              {flight3.Segments[1].map((segment, index) => (
                <div>
                  <div className="FlghtBoxNew mt-5 ng-scope">
                    <div className="clr" />

                    <div className="card-head  d-flex gap-10 align-items-center">
                      <img
                        src={`/Images/AirlineLogo/${segment.Airline.AirlineCode}.gif`}
                      />
                      <div className="flt-nm">
                        <span
                          className="fnt-600 ng-binding"
                          ng-bind="l.airName"
                        >
                          {segment.Airline.AirlineName}
                        </span>{" "}
                        |{" "}
                        <span className="fnt-500 fnt-15 ng-binding">
                          {" "}
                          {segment.Airline.AirlineCode}-
                          {segment.Airline.FlightNumber}
                        </span>
                      </div>

                      <span className="rfnd-btn fnt-10 ng-binding ng-scope">
                        {flight3.refundtype === "Refundable"
                          ? "Refundable"
                          : "Non Refundable"}
                      </span>
                    </div>

                    <span
                      className="secre ng-binding ng-scope"
                      style={{ display: "block" }}
                    >
                      {flight3.ResultFareType} |{" "}
                      {cabinClass[segment.CabinClass]}
                    </span>

                    <div className="card-body d-flex justify-content-between gap-10 align-items-center1">
                      <div className="ft-frm w-35 ">
                        <div className="fnt-12 clr-drkgrey ng-binding">
                          {formatTime(segment.Origin.DepTime)}
                        </div>
                        <div className="d-flex gap-5">
                          <div className="frm fnt-16 fnt-600 ng-binding">
                            {" "}
                            {segment.Origin.Airport.CityCode}
                          </div>
                          <div className="fnt-16 fnt-600 ng-binding">
                            {" "}
                            {new Date(
                              segment.Origin.DepTime
                            ).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            })}
                          </div>
                        </div>
                        <div className="clr-drkgrey fnt-15 fw600 ng-binding">
                          {segment.Origin.Airport.CityName}
                        </div>

                        <div className="clr-drkgrey fnt-10 arpt ng-binding ng-scope">
                          {segment.Origin.Airport.Terminal !== "" && (
                            <>Terminal - {segment.Origin.Airport.Terminal}</>
                          )}
                        </div>
                      </div>
                      <div
                        className="jrny w-20 text-center"
                        style={{ margin: "10px auto" }}
                      >
                        <div className="clr-drkgrey fnt-11 ng-binding">
                          <span> ... </span> {segment.Duration} {" "}
                          <span> ...</span>
                        </div>
                      </div>
                      <div className="ft-to w-35 text-end">
                        <div className="fnt-12 clr-drkgrey ng-binding">
                          {formatTime(segment.Destination.ArrTime)}
                        </div>
                        <div className="d-flex gap-5 justify-content-end">
                          <div className="frm fnt-16 fnt-600 ng-binding">
                            {" "}
                            {segment.Destination.Airport.CityCode}
                          </div>
                          <div className="fnt-16 fnt-500 ng-binding">
                            {" "}
                            {new Date(
                              segment.Destination.ArrTime
                            ).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            })}
                          </div>
                        </div>
                        <div className="clr-drkgrey fnt-16 fw600 ng-binding">
                          {segment.Destination.Airport.CityName}
                        </div>
                        <div className="clr-drkgrey fnt-10 arpt ng-binding ng-scope">
                          {segment.Destination.Airport.Terminal !== "" && (
                            <>
                              Terminal - {segment.Destination.Airport.Terminal}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {index < flight3.Segments[1].length - 1 && (
                    <div className="FlghtBoxNew mt-5 ng-scope">
                      <div className="clr" />

                      <div className="lyovr  ng-scope">
                        <span className="ng-binding">
                          {segment.Layover}{" "}
                          Layover{" "}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default DepatureDetail;
